import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapPhoneNumberInput = React.lazy(function () {
    return import('../../bootstrap-components/components/BTPhoneNumberInput');
});
var bootStrapPhoneNumberInput = function (props) {
    return (React.createElement(BootStrapPhoneNumberInput, { handleChange: props.handleChange, styleName: props.hasError ? 'danger' : props.styleName, label: props.label, height: props.height, disabled: props.disabled, width: props.width, ioTheme: props.ioTheme, ioMode: props.ioMode, style: props.style, mandatory: props.mandatory, placeHolder: props.placeHolder, hasError: props.hasError, errorMessage: props.errorMessage, displayType: props.displayType, value: props.value, defaultValue: props.defaultValue, configId: props.configId, type: props.type, icon: props.icon, isInlineGridComponent: props.isInlineGridComponent, handleIconClick: props.handleIconClick, iconClicked: props.iconClicked, isFilterComponent: props.isFilterComponent, onBlur: props.onBlur, occuranceNumber: props.occuranceNumber }));
};
export var PhoneNumberInput = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapPhoneNumberInput(props);
        default:
            componentToDisplay = bootStrapPhoneNumberInput(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
PhoneNumberInput.defaultProps = {
    styleName: 'primary',
    label: 'TextBox',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=PhoneNumberInput.js.map